/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import AggregateCard from "./AggregateCard";
import AggregateSentimentCard from "./AggregateSentimentCard";
import { useSelector } from "react-redux";
const SplitAggregateChart = ({
  data,
  datatype,
  description,
  splitFinalObj,
  columns,
  isdownload,
  splitcolumncount,
}) => {
  const graphFilter = useSelector((state) => state.Welcome.graphDetail?.filter);
  const graphSplit = useSelector((state) => state.Welcome.graphDetail?.split);
  let dashboardFilter =
    (data && data?.[0]?.title === "Mentions with Split") || data?.[0]?.id == 7;
  let filter = dashboardFilter
    ? [1]
    : graphFilter
    ? graphFilter
    : graphSplit
    ? graphSplit
    : splitFinalObj?.columns;
  const [size, setSize] = useState(1340);

  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth]);
    };
    window.addEventListener("resize", updateSize);
    // updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  let idsList;
  let data_map = [];

  if (filter) {
    idsList = [6, 7, 10, 8, 9];

    data &&
      idsList?.forEach((e) => {
        data &&
          data_map.push(
            data?.filter((e1) => {
              return e1.id == e;
            })[0]
          );
      });
  } else {
    datatype === "varchar"
      ? (idsList = [1, 2, 4, 3, 6])
      : (idsList = [1, 2, 4, 3, 5]);

    data &&
      idsList?.forEach((e) => {
        data &&
          data_map?.push(
            data?.filter((e1) => {
              return e1.id == e;
            })[0]
          );
      });
  }

  if (
    (graphSplit && graphSplit?.columns?.length === 2) ||
    (columns && columns === 2) ||
    (splitFinalObj && splitFinalObj?.columns?.length === 2)
  ) {
    return (
      <div className="bg__white p-15 pb-0 mb-15">
        {data && (
          <div className="row">
            <div className="col-12">
              <div className="row ml-md-0">
                <div
                  className={`col-12 ${
                    size < 1024 ? "col-md-12 pl-md-0" : "col-md-6 pl-md-0"
                  }`}
                >
                  <AggregateCard
                    data={data_map?.length > 0 && data_map[0]}
                    filter={graphSplit ? 1 : filter?.length}
                    id={idsList[0]}
                    split="split"
                  />
                </div>
                <div
                  className={`col-12 ${
                    size < 1024 ? "col-md-12 pl-md-0" : "col-md-6 pl-md-0"
                  }`}
                >
                  <AggregateCard
                    data={data_map && data_map[1]}
                    filter={graphSplit ? 1 : filter?.length}
                    split="split"
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              {(data_map[2] || data) && (
                <AggregateSentimentCard
                  data={data?.length === 0 ? null : data_map[2]}
                  filter={graphSplit ? 1 : filter?.length}
                  description={description}
                  columns={columns}
                />
              )}
            </div>
            <div className="col-12 last-column">
              <div className="row ml-md-0">
                <div
                  className={`col-12 ${
                    size < 1024 ? "col-md-12 pl-md-0 mb-15" : "col-md-6 pl-md-0"
                  }`}
                >
                  <AggregateCard
                    data={data_map && data_map[3]}
                    filter={graphSplit ? 1 : filter?.length}
                    split="split"
                  />
                </div>
                <div
                  className={`col-12 ${
                    size < 1024 ? "col-md-12 pl-md-0" : "col-md-6 pl-md-0"
                  }`}
                >
                  <AggregateCard
                    data={data_map && data_map[4]}
                    datatype={datatype}
                    filter={graphSplit ? 1 : filter?.length}
                    id={idsList[4]}
                    split="split"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else if (
    (graphSplit && graphSplit.columns?.length === 3) ||
    (columns && columns === 3) ||
    (splitFinalObj && splitFinalObj?.columns?.length === 3)
  ) {
    return (
      <>
        {data && (
          <div className="row">
            <div className="col-12">
              <AggregateCard
                data={data_map?.length > 0 && data_map[0]}
                filter={graphSplit ? 1 : filter?.length}
                id={idsList[0]}
                isdownload={isdownload}
                splitcolumncount={splitcolumncount}
                split="split"
              />
              <AggregateCard
                data={data_map?.length > 0 && data_map[1]}
                filter={graphSplit ? 1 : filter?.length}
                isdownload={isdownload}
                splitcolumncount={splitcolumncount}
                split="split"
              />
            </div>
            <div className="col-12">
              {(data_map[2] || data) && (
                <AggregateSentimentCard
                  data={data?.length === 0 ? null : data_map[2]}
                  filter={graphSplit ? 1 : filter?.length}
                  description={description}
                  columns={columns}
                  isdownload={isdownload}
                  splitcolumncount={splitcolumncount}
                />
              )}
            </div>
            <div className="col-12 last-column">
              <AggregateCard
                data={data_map?.length > 0 && data_map[3]}
                filter={graphSplit ? 1 : filter?.length}
                isdownload={isdownload}
                splitcolumncount={splitcolumncount}
                split="split"
              />
              <AggregateCard
                data={data_map?.length > 0 && data_map[4]}
                datatype={datatype}
                filter={graphSplit ? 1 : filter?.length}
                id={idsList[4]}
                isdownload={isdownload}
                splitcolumncount={splitcolumncount}
                split="split"
              />
            </div>
          </div>
        )}
      </>
    );
  } else {
    return <></>;
  }
};

export default SplitAggregateChart;
